import { Reducer } from "redux";

import { MasterDocumentTypeResponse } from "../models/api/Master";
import { MasterDocumentTypeDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterDocumentTypeActionDispatchTypes } from "../constants/Master";

const initialState: MasterDocumentTypeResponse = {
  loading: false,
  response: [],
  error: null,
};

const MasterDocumentTypeReducer: Reducer<
  MasterDocumentTypeResponse,
  MasterDocumentTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterDocumentTypeActionDispatchTypes.MASTER_DOCUMENT_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterDocumentTypeActionDispatchTypes.MASTER_DOCUMENT_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MasterDocumentTypeActionDispatchTypes.MASTER_DOCUMENT_TYPE_ERRORS: {
      return initialState;
    }
  }
  return state;
};

export default MasterDocumentTypeReducer;
